import React from 'react';
import { useNavigate } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import { formatCurrency } from '../../utils/helpers';

const ProjectCard = ({ project, onClick }) => {
  const navigate = useNavigate();

  const handleAction = (e, section) => {
    e.stopPropagation();
    navigate(`/projects/${project.id}?section=${section}`);
  };

  const selectedProducts = Array.isArray(project.selectedProducts) ? project.selectedProducts : [];
  const productCount = Array.isArray(project.selectedProductIds)
    ? project.selectedProductIds.length
    : selectedProducts.length;
  const estimatedValue = Number(project.estimatedProjectValue || 0);
  const productNames = selectedProducts
    .slice(0, 2)
    .map(product => product.name)
    .filter(Boolean)
    .join(', ');
  const status = project.status || 'Planlagt';
  const displayStatus = status === 'active' ? 'Aktiv' : status;

  return (
    <div onClick={onClick} className="group bg-white rounded-2xl border border-slate-200 shadow-sm hover:shadow-xl hover:border-primary-200 transition-all duration-300 cursor-pointer flex flex-col h-full overflow-hidden">
      <div className="p-6">
        <div className="flex justify-between items-start mb-4">
          <div className="p-3 bg-primary-50 rounded-xl group-hover:bg-primary-100 transition-colors duration-300">
            <SafeIcon icon="💼" className="w-6 h-6 text-primary-600" />
          </div>
          <span className={`px-2.5 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider ${displayStatus === 'Aktiv' ? 'bg-emerald-100 text-emerald-700' : 'bg-slate-100 text-slate-600'}`}>
            {displayStatus}
          </span>
        </div>
        <h3 className="text-xl font-bold text-slate-900 mb-2 group-hover:text-primary-700 transition-colors line-clamp-1">
          {project.name}
        </h3>
        <p className="text-sm text-slate-500 mb-6 line-clamp-2 leading-relaxed">
          {project.description}
        </p>
        <div className="grid grid-cols-2 gap-6 py-4 border-t border-slate-50">
          <div>
            <div className="flex items-center gap-1.5 text-slate-400 mb-1">
              <SafeIcon icon="🎯" className="w-3.5 h-3.5" />
              <span className="text-[10px] font-bold uppercase tracking-tight">Budsjett</span>
            </div>
            <p className="text-sm font-bold text-slate-900">{formatCurrency(project.budget || 0)}</p>
          </div>
          <div>
            <div className="flex items-center gap-1.5 text-slate-400 mb-1">
              <SafeIcon icon="📈" className="w-3.5 h-3.5" />
              <span className="text-[10px] font-bold uppercase tracking-tight">Mål</span>
            </div>
            <p className="text-sm font-bold text-slate-900">{formatCurrency(project.target || 0)}</p>
          </div>
        </div>

        {productCount > 0 && (
          <div className="pt-4 border-t border-slate-100">
            <p className="text-xs font-bold text-slate-700">{productCount} produkter/tjenester</p>
            {estimatedValue > 0 && (
              <p className="text-xs text-slate-500 mt-1">Estimert verdi: {formatCurrency(estimatedValue)}</p>
            )}
            {productNames && (
              <p className="text-xs text-slate-500 mt-1 line-clamp-1">{productNames}</p>
            )}
          </div>
        )}
      </div>
      <div className="mt-auto p-2 bg-slate-50/50 border-t border-slate-100 flex items-center justify-between">
        <div className="flex gap-1">
          <button onClick={e => handleAction(e, 'pitch')} className="p-2 text-slate-400 hover:text-primary-600 hover:bg-white rounded-lg transition-all" title="Salgs-pitch">
            <SafeIcon icon="🎤" className="w-4 h-4" />
          </button>
          <button onClick={e => handleAction(e, 'crm')} className="p-2 text-slate-400 hover:text-primary-600 hover:bg-white rounded-lg transition-all" title="Pipeline">
            <SafeIcon icon="💰" className="w-4 h-4" />
          </button>
          <button onClick={e => handleAction(e, 'documentation')} className="p-2 text-slate-400 hover:text-primary-600 hover:bg-white rounded-lg transition-all" title="Dokumentasjon">
            <SafeIcon icon="📄" className="w-4 h-4" />
          </button>
        </div>
        <div className="flex items-center text-primary-600 text-xs font-bold group-hover:translate-x-1 transition-transform pr-2">
          Se kanvas <SafeIcon icon="➡️" className="ml-1.5 w-3.5 h-3.5" />
        </div>
      </div>
    </div>
  );
};

export default ProjectCard;